// @ts-nocheck
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */

type InterrogatableNode = Node & ParentNode & Partial<HTMLElement>;

const tabbableNode = /input|select|textarea|button|object/;

function hidesContents(element: Node & ParentNode & HTMLElement) {
    const zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;

    // If the node is empty, this is good enough
    if (zeroSize && !element.innerHTML) {
        return true;
    }

    // Otherwise we need to check some styles
    const style = window.getComputedStyle(element);
    return zeroSize ? style.getPropertyValue("overflow") !== "visible" : style.getPropertyValue("display") === "none";
}

function visible(element: InterrogatableNode) {
    let parentElement: InterrogatableNode | null = element;
    while (parentElement) {
        if (parentElement === document.body) {
            break;
        }
        if (hidesContents(parentElement as HTMLElement)) {
            return false;
        }
        parentElement = parentElement.parentNode as InterrogatableNode;
    }
    return true;
}

function focusable(
    element: InterrogatableNode & { disabled: boolean; href: string; tabIndex: string /* Starter Custom Code */ },
    isTabIndexNotNaN: boolean,
) {
    const nodeName = element.nodeName.toLowerCase();
    /* Starter Custom Code - Start */
    const computedStyles = window.getComputedStyle(element as Element);
    const res =
        computedStyles.visibility !== "hidden" &&
        !element.disabled &&
        (Number(element.tabIndex) >= 0 ||
            tabbableNode.test(nodeName) ||
            (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN));
    /* Starter Custom Code - End */

    return res && visible(element);
}

function tabbable(element: HTMLElement) {
    let tabIndex = element.getAttribute("tabindex");
    if (tabIndex === null) {
        tabIndex = null;
    }
    const isTabIndexNaN = typeof tabIndex !== "number" || Number.isNaN(tabIndex);
    return (
        (isTabIndexNaN || Number(tabIndex) >= 0) &&
        focusable(
            element as InterrogatableNode & {
                disabled: boolean;
                href: string;
                tabIndex: string; // Starter Custom Code
            },
            !isTabIndexNaN,
        )
    );
}

export default function findTabbableDescendants(element: HTMLElement) {
    /* Starter Custom Code - Start */
    return Array.from(element.querySelectorAll<HTMLElement>("*")).reduce((result, x) => {
        if (!tabbable(x)) {
            return result;
        }

        if (x.getAttribute("type") === "radio") {
            const radioName = x.getAttribute("name");
            if (radioName && result.find(y => y.getAttribute("name") === radioName)) {
                return result;
            }
        }

        return [...result, x];
    }, [] as HTMLElement[]);
    /* Starter Custom Code - End */
}
